
import { Component, Mixins } from 'vue-property-decorator';
import SidenaviNewentries from './';
@Component
export default class SidenaviNewentriesJa extends Mixins(SidenaviNewentries) {

}
